import axios from "axios";
import { Language } from "../models";

export const getLanguages = () => {
    return axios.get<Language[]>(`Languages`);
}

export const redirectToLanguageHome = (
    langCode: string
): void => {
    localStorage.setItem("lang", langCode);
    window.location.href = `/${langCode}`;
};

export const getLanguageCode = (): string => {
    const lang = localStorage.getItem("lang");

    if (lang) {
        return lang;
    }

    const host = window.location.hostname.toLowerCase();

    if (
        host.endsWith(".be") ||
        host.endsWith(".fr") ||
        host.endsWith(".lu")
    ) {
        return "fr";
    }

    if (host.endsWith(".nl")) {
        return "nl";
    }

    return "en";
};